export { default } from "./DeleteAssignmentOption";
